<template>
  <a-card bordered class="loading">
    <div style="min-width: 35vw;min-height: 30vh; display: flex;flex-direction: column">
      <div style="font-weight: bold;font-size: 16px;width: 100%;display: flex;justify-content: space-between">
        当前网关下的地锁({{ single.gateWayLock.length }})
        <a-button type="primary" @click="single.getlocks">刷新</a-button>
      </div>
      <a-spin :spinning="single.lockSate">
        <div style="padding: 10px;box-sizing: border-box">
          <a-row :gutter="16">
            <a-col :span="8" v-for="(item,index) in single.gateWayLock" :key="index">
              <a-card
                  :style="{width:'100%',marginBottom:'10px',background:item.online?'#ceffce':'#fdcbcd',color:'#000'}"
                  :title="item.uniqueCode">
                <p>地锁在线状态: {{ item.online === 1 ? '在线' : '掉线' }}</p>
                <p>地锁电量: {{ item.battery }}%</p>
                <p>地锁当前状态:
                  {{
                    item.lockState == '1' ? '升锁' : item.lockState == '2' ? '降锁' : item.lockState == '3' ? '升过头' : '半升锁'
                  }}</p>
                <p>超声波状态: {{ item.hasCar == '1'  ? '有车' : '无车' }}</p>
                <p>车位模式: {{ item.lockMode == '1' ? '普通模式' : '预约模式' }}</p>
                <p>报警阈值: {{ item.alarmLimited || '--' }}</p>
                <p>超声波距离: {{ item.ultra || '--' }}cm</p>
<!--                <p v-if="item.online == '1'">地锁模式:</p>
                <p v-if="item.online == '1'">
                  <a-select
                      ref="select"
                      v-model:value="item.workMode"
                      :style="{width: '120px'}"
                  >
                    <a-select-option :value="0">普通模式</a-select-option>
                    <a-select-option :value="1 ">超声波联动</a-select-option>
                    <a-select-option :value="2">禁用钥匙(超声波)</a-select-option>
                  </a-select>
                  <a-tooltip title="提交地锁模式" color="#2db7f5">
                    <a-button type="primary" shape="circle" :size="'small'" @click="issuedThreshold(item)">
                      <template #icon>
                        <to-top-outlined/>
                      </template>
                    </a-button>
                  </a-tooltip>
                </p>-->
                <p>地锁模式: {{
                    item.workMode == '0' ? '普通模式' : item.workMode == '1' ? '超声波联动' : item.workMode == '2' ? '禁用钥匙(超声波)' : '--'
                  }}</p>
                <p v-if="item.online == '1'">超声波阈值(cm):</p>
                <p>
                  <a-space v-if="item.online == '1'">
                    <a-input-number
                        v-model:value="item.ultraThreshold"
                        :style="{width:'80px'}"
                        :min="0"
                        placeholder="输入超声波阈值"
                    />
                    <a-tooltip title="提交超声波阈值" color="#2db7f5">
                      <a-button type="primary" shape="circle" :size="'small'" @click="issuedThreshold(item)">
                        <template #icon>
                          <to-top-outlined/>
                        </template>
                      </a-button>
                    </a-tooltip>
                  </a-space>
                  <template v-else> 超声波阈值:{{ item.ultraThreshold }}cm</template>
                </p>
                <p>电池电压: {{ (Number(Number(item.voltage) * 7.2) / 100).toFixed(2) || '--' || '--' }}v</p>
                <p>地锁车位号: {{ item.parkNum || '--' }}</p>
                <p>地锁版本: {{ item.version || '--' }}</p>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </div>
  </a-card>
</template>
<script setup>
import singleDev from '@/stores/singleDev'
import {ToTopOutlined} from "@ant-design/icons-vue"
import mqttTool from "@/utils/mqtt";
import load from "@/common/load";

let single = singleDev();
let issuedThreshold = (item) => {
  // 传递消息的方法
  mqttTool.deliverTheMessage = (topic, message) => {
    console.log(topic)
    console.log(message)
  };
  if (mqttTool.subscribeSuccess) {
    mqttTool.doUnSubscribe();
  }
  mqttTool.subscription.topic = '/Beefind/prep/v1/up/lockgateway/set_lockparams/'
  // 订阅主题
  mqttTool.doSubscribe();
  mqttTool.publish.topic = '/Beefind/prep/v1/down/lockgateway/set_lockparams/'
  // 发布信息
  mqttTool.publish.payload = JSON.stringify({
    'devices': [item.uniqueCode],
    'data': {
      'ultraThreshold': item.ultraThreshold,
      'workMode': item.workMode,
    }
  });
  mqttTool.doPublish();
  load.loading("加载最新地锁数据...");
  single.getlocks(true);
}
</script>
<style>
.ant-card-head {
  display: flex !important;
}
</style>
<style scoped lang="scss">
.loading {
  display: flex;
  min-width: 35vw;
  min-height: 30vh;
  align-items: center;
  justify-content: center;
}
</style>
